import React, {useEffect, useState} from 'react'
import {Button, Form, Input, Modal, AutoComplete, DatePicker, Select} from "antd";
import {getAllCustomer} from "../../services/serviceCustomer";
import {createAppointment} from "../../services/serviceAppointment";
import {getRelevantPersonByCustomer} from "../../services/serviceRelevantPerson";
import {exitLoadingState, enterLoadingState} from "../../utils/helpers/commonFunctions";
import {getBrandsAsSelect} from "../../services/serviceBrand";
import moment from 'moment';

const {TextArea} = Input
const {Option} = AutoComplete
const formLayout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16}
}
const statuses = [
    {
        value: "WAITING",
        text: "BEKLEMEDE"
    },
    {
        value: "NEGATIVE",
        text: "OLUMSUZ"
    },
    {
        value: "POSITIVE",
        text: "OLUMLU"
    }
]
const dateFormat = 'DD/MM/YYYY HH:mm'


const AppointmentCreate = ({show, modalCloser, updater}) => {
    const [form] = Form.useForm();
    const [status, setStatus] = useState('WAITING');
    const [customers, setCustomers] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState();
    const [representatives, setRepresentatives] = useState([]);
    const [selectedRepresentative, setSelectedRepresentative] = useState();
    const [loadings, setLoadings] = useState([]);
    const [brands, setBrands] = useState([]);

    useEffect(() => {
        getAllCustomer()
            .then(({data}) => {
                let customerData = [];
                data.forEach(item => {
                    let pushObj = {
                        value: item.id,
                        text: item.name
                    }
                    customerData.push(pushObj);
                })
                setCustomers(customerData);
            })
    }, [])

    useEffect(() => {
        getBrandsAsSelect()
            .then(({data}) => {
                if(data) {
                    const structured = data.map(brand => {
                        return {value: brand.key, label: brand.label}
                    })
                    setBrands(structured)
                };
            })
    }, [])

    const handleSubmit = (list) => {
        enterLoadingState(setLoadings)

        let requestObj = {
            relevantPerson: selectedRepresentative ? {id: selectedRepresentative} : null,
            customer: selectedCustomer ? {id: selectedCustomer} : null,
            resultText: list.appointmentResult,
            title: list.appointmentTitle,
            status: status,
            brand: list.appointmentBrand ? {id: list.appointmentBrand} : null,
            planningDate: list.appointmentDate._d ? moment(list.appointmentDate._d ).format(('YYYY-MM-DDTHH:mm:ss')) : null
        }

        createAppointment(requestObj)
            .then(() => {
                exitLoadingState(setLoadings)
                modalCloser()
                updater()
            })
            .catch(() => exitLoadingState(setLoadings))
            .finally(() => exitLoadingState(setLoadings))
    }

    const statusChanged = (v, o) => setStatus(o.key)

    const customerChanged = (v, o) => {
        if (o.key) {
            getRelevantPersonByCustomer(o.key)
                .then(({data}) => {
                    const representativeData = data.map(item => {
                        return {
                            value: item.id,
                            text: `${item.name} ${item.surname}`
                        }
                    })
                    setRepresentatives(representativeData)
                })
        }
        setSelectedCustomer(o.key)
    }
    const representativeChange = (v, o) => setSelectedRepresentative(o.key);
    const selectSearch = (input, option) => {
        return (option?.label ?? '').toLocaleLowerCase('tr').includes(input.toLocaleLowerCase('tr'));
    };

    return (
        <React.Fragment>
            <Modal
                title={'Randevu Oluştur'}
                open={show}
                closable={false}
                footer={[
                    <Button
                        type={'primary'}
                        key={'SubmitButton'}
                        loading={loadings[0]}
                        onClick={() => {
                            form.submit()
                        }}
                    >
                        Kaydet
                    </Button>,
                    <Button
                        onClick={() => modalCloser()}
                        key={'CancelButton'}
                    >
                        Kapat
                    </Button>
                ]}
            >
                <Form
                    form={form}
                    {...formLayout}
                    onFinish={() => handleSubmit(form.getFieldsValue())}
                    labelAlign={"left"}
                >
                    <Form.Item
                        label={'Müşteri'}
                        name={'appointmentCustomer'}
                        rules={[
                            {required: true, message: 'Bu alan boş bırakılamaz'},
                            () => ({
                                validator(rule, value) {
                                    let hasValue = customers.filter(customer => customer.text.toLowerCase() === value.toLowerCase())
                                    if (value && hasValue.length > 0) {
                                        customerChanged(true, {key: hasValue[0].value})
                                        return Promise.resolve();
                                    }

                                    return Promise.reject('Lütfen Bir Değer Seçiniz');
                                },
                            })
                        ]}
                    >
                        <AutoComplete
                            filterOption={(inputValue, option) =>
                                option.value.toLocaleUpperCase().indexOf(inputValue.toLocaleUpperCase()) !== -1
                            }
                        >
                            {customers.map(({value, text}) => (
                                <Option key={value} value={text}>{text}</Option>
                            ))}
                        </AutoComplete>
                    </Form.Item>
                    <Form.Item
                        label={'Marka'}
                        name={'appointmentBrand'}
                    >
                        <Select options={brands} showSearch filterOption={selectSearch} />
                    </Form.Item>
                    <Form.Item
                        label={'Konu'}
                        name={'appointmentTitle'}
                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label={'İlgili'}
                        name={'appointmentEmployee'}
                        rules={[
                            {required: true, message: 'Bu alan boş bırakılamaz'},
                            () => ({
                                validator(rule, value) {
                                    let hasValue = representatives.filter(rep => rep.text.toLowerCase() === value.toLowerCase())
                                    if (value && hasValue.length > 0) {
                                        representativeChange(true, {key: hasValue[0].value})
                                        return Promise.resolve();
                                    }

                                    return Promise.reject('Lütfen Bir Değer Seçiniz');
                                },
                            })
                        ]}
                    >
                        <AutoComplete
                            filterOption={(inputValue, option) =>
                                option.value.toLocaleUpperCase().indexOf(inputValue.toLocaleUpperCase()) !== -1
                            }
                        >
                            {representatives.map(({value, text}) => (
                                <Option key={value} value={text}>{text}</Option>
                            ))}
                        </AutoComplete>
                    </Form.Item>
                    <Form.Item
                        label={'Sonuç Raporu'}
                        name={'appointmentResult'}
                    >
                        <TextArea rows={6}/>
                    </Form.Item>
                    <Form.Item
                        label={'Randevu Tarihi'}
                        name={'appointmentDate'}
                        rules={[
                            {required: true, message: 'Bu alan boş bırakılamaz'}
                        ]}
                    >
                        <DatePicker showTime format={dateFormat} placeholder={'Tarih seçiniz'}/>
                    </Form.Item>
                    <Form.Item
                        label={'Durum'}
                        name={'appointmentStatus'}
                        initialValue={statuses[0].text}
                    >
                        <AutoComplete
                            onChange={statusChanged}
                        >
                            {statuses.map(({value, text}) => {
                                return <Option key={value} value={text}>{text}</Option>
                            })}

                        </AutoComplete>
                    </Form.Item>
                </Form>
            </Modal>
        </React.Fragment>
    )
}
export default AppointmentCreate